<template>
  <div class="stopwatch">
    <div
      @click.prevent.stop="start"
      class="stopwatch--init d-flex justify-content-between align-items-center px-1"
      :class="{ stopwatch__pointer: isFirstTime }"
      v-if="isFirstTime && showActions"
    >
      <i class="material-icons-outlined">watch_later</i>
      <span class="text-center">Start Timer</span>
    </div>
    <section v-else class="d-flex justify-content-between align-items-center px-1">
      <div v-if="!showActions">
        <span class="material-icons-outlined">watch_later</span>
      </div>
      <span class="stopwatch__time">{{ formattedElapsedTime }}</span>
      <span
        v-if="showActions"
        @click.prevent.stop="handleTimer"
        class="icon-container material-icons stopwatch__pointer"
      >
        {{ icon }}
      </span>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    showActions: {
      type: Boolean,
      default: true,
    },
    defaultTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      millisecondsPerSecond: 1000,
      secondsPerHour: 3600,
      secondsPerMinute: 60,
      elapsedTimeInMiliseconds: 0,
      startTime: 0,
      running: false,
    };
  },
  inject: ['activeTimerProvider'],
  mounted() {
    this.elapsedTimeInMiliseconds = Math.floor(this.defaultTime * this.millisecondsPerSecond);
  },
  computed: {
    formattedElapsedTime() {
      const elapsedTimeInSeconds = this.elapsedTimeInMiliseconds / this.millisecondsPerSecond;
      const hours = Math.floor(elapsedTimeInSeconds / this.secondsPerHour);
      const minutes = Math.floor(
        (elapsedTimeInSeconds % this.secondsPerHour) / this.secondsPerMinute,
      );
      const seconds = Math.floor(elapsedTimeInSeconds % this.secondsPerMinute);

      const hoursElapsed = hours.toString().padStart(2, '0');
      const minutesElapsed = minutes.toString().padStart(2, '0');
      const secondsElapsed = seconds.toString().padStart(2, '0');
      const elapsedTime = `${hoursElapsed}:${minutesElapsed}:${secondsElapsed}`;

      if (this.running) document.title = elapsedTime;
      return elapsedTime;
    },
    isFirstTime() {
      return this.elapsedTimeInMiliseconds === 0;
    },
    icon() {
      return this.running ? 'paused' : 'play_arrow';
    },
  },
  methods: {
    start() {
      if (this.activeTimerProvider.activeTimer && this.activeTimerProvider.activeTimer !== this) {
        this.stopActiveTimer();
      }
      this.activeTimerProvider.activeTimer = this;
      this.startTime = Date.now() - this.elapsedTimeInMiliseconds;
      this.running = true;
      this.timer = setInterval(() => {
        this.elapsedTimeInMiliseconds = Date.now() - this.startTime;
      }, 10);
      if (this.isFirstTime && this.showActions) {
        this.toggleTimer('run');
      }
      window.addEventListener('beforeunload', this.handleUnload);
    },
    stop() {
      clearInterval(this.timer);
      this.running = false;
      document.title = 'atom';
      this.activeTimerProvider.activeTimer = null;
      window.removeEventListener('beforeunload', this.handleUnload);
    },
    reset() {
      this.elapsedTimeInMiliseconds = 0;
    },
    handleTimer() {
      this.running ? this.stop() : this.start();
      const state = this.running ? 'run' : 'pause';

      this.toggleTimer(state);
    },
    handleUnload(event) {
      this.stopActiveTimer();
      event.returnValue = '';
      return event.returnValue;
    },
    toggleTimer(state) {
      this.$emit('toggleTimer', { state });
    },
    stopActiveTimer() {
      this.activeTimerProvider.activeTimer.toggleTimer('pause');
      this.activeTimerProvider.activeTimer.stop();
    },
  },
  beforeDestroy() {
    if (this.running) this.stopActiveTimer();
  },
};
</script>

<style lang="scss" scoped>
.stopwatch {
  width: max(100px, 8rem);
  background-color: #58e1ea;
  padding: 6px 8px;
  border-radius: 20px;
  line-height: 0;

  &--init {
    color: white;
  }

  &__time {
    align-items: center;
    white-space: nowrap;
    color: white;
  }
  &__pointer {
    cursor: pointer;
  }
  .icon-container {
    width: 24px;
  }
  .material-icons-outlined,
  .material-icons {
    font-size: 20px;
    color: white;
  }
}
</style>
